import React, { useState } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";

import { Popover, PopoverContent, PopoverAnchor } from "app/components/Popover";
import CustomTooltip from "app/components/Tooltip";
import { SettingIcon } from "app/components/Icons/Setting";

import { selectDraftBoardForm } from "../../../../components/Settings/redux/selector";
import { selectUserFormData } from "app/redux/selector";
import { useBoardsActions } from "../../../../components/useBoardsActions";

import TicketLimitEditor from "./TicketLimitEditor";
import { TicketGroup } from "../../../Tickets/types";

interface Props {
  count: number;
  maxCount: number;
  group: TicketGroup;
}

const TicketLimit: React.FC<Props> = ({ count, maxCount, group }) => {
  const [open, setOpen] = useState(false);

  const { _id: boardId } = useSelector(selectDraftBoardForm);
  const { selectedProjectId } = useSelector(selectUserFormData);
  const { updateBoardsGroupsJson } = useBoardsActions(selectedProjectId);

  const tooltipContent = (
    <div className="flex flex-col w-full space-y-2 ">
      <div className=" flex flex-row items-center justify-between gap-1">
        <span className="text-sm text-white">Tickets amount:</span>
        <span className="text-sm text-white w-fit ">
          {count}/{maxCount}
        </span>
      </div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        className="flex items-center gap-1 text-primary text-xs font-medium"
      >
        <SettingIcon color="#5A8DF1" size={18} />
        <span className="">Set tickets’ limit</span>
      </button>
    </div>
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverAnchor asChild>
        <div className="relative">
          <CustomTooltip
            text={tooltipContent}
            contentClassName="min-w-[200px] py-[14px]"
          >
            <button
              className={clsx(
                "flex items-center justify-center px-[6px] min-h-5 rounded-full text-xs border",
                count > maxCount
                  ? "border-danger bg-danger100 text-danger"
                  : "border-gray-100 text-secondary hover:bg-gray-400",
              )}
            >
              {maxCount ? `${count}/${maxCount}` : count}
            </button>
          </CustomTooltip>
        </div>
      </PopoverAnchor>

      <PopoverContent
        side="bottom"
        align="start"
        sideOffset={6}
        className="!p-0 bg-white border border-gray-100 z-50"
      >
        <TicketLimitEditor
          maxCount={maxCount}
          group={group}
          boardId={boardId}
          onClose={() => setOpen(false)}
          updateBoardsGroupsJson={updateBoardsGroupsJson}
        />
      </PopoverContent>
    </Popover>
  );
};

export default React.memo(TicketLimit);
